import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { BusinessUnitService } from '@fi-app/business-unit/business-unit.service';
import { Transition } from '@uirouter/angular';

export const FiBusinessUnitStateResolveBusinessUnit = [
    FiStateService,
    BusinessUnitService,
    Transition,
    FiBusinessUnitStateResolveBusinessUnit_resolveFunc,
];

export function FiBusinessUnitStateResolveBusinessUnit_resolveFunc(
    fiStateService: FiStateService,
    businessUnitService: BusinessUnitService,
    tr: Transition,
) {
    return businessUnitService.getBusinessUnit(fiStateService.getParams(tr).Id);
}
